export default {"src":"/_next/static/media/lock_40.a57587e9.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};